export const STORE_EVENT_NOTIFICATIONS_NAME = "eventNotifications"

export const STATE_EVENT_NOTIFICATIONS_LIST = "list"
export const GETTER_EVENT_UNREAD_NOTIFICATIONS = "unreadNotifications"
export const MUTATION_EVENT_NOTIFICATIONS_SET = "setNotifications"
export const MUTATION_EVENT_NOTIFICATIONS_REMOVE = "setNotificationRead"
export const ACTION_EVENT_NOTIFICATIONS_FETCH = "fetchNotifications"
export const ACTION_EVENT_NOTIFICATIONS_MARK_AS_READ = "markAsRead"
export const ACTION_EVENT_NOTIFICATIONS_MARK_ALL_AS_READ = "markAllAsRead"
